import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import type { RouteContext } from '@townsquare/router/routing-types';
import { peopleDirectoryRoute } from '@townsquare/routes/people-directory-view';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { peopleDirectoryTableResource } from './resources/people-directory-table';

const PeopleDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () =>
		import(/* webpackChunkName: "peopleDirectory-view" */ './components/PeopleDirectory'),
	loading: () => null,
});

peopleDirectoryRoute.component = PeopleDirectoryLoadable;
peopleDirectoryRoute.resources = [tqlExplainerResource, peopleDirectoryTableResource];
export const peopleDirectoryRouterRoute: GlobalHomePageRoute = peopleDirectoryRoute;
